import React from 'react';
// import logo from './logo.svg';
import './App.css';
import PointCloudPage from './containers/PointCloudPage';
import WelcomePage from './containers/WelcomePage';
import {BrowserRouter as Router, Route, Switch, useLocation, withRouter} from 'react-router-dom'
import { TransitionGroup, CSSTransition } from "react-transition-group";

function Transition({location}) {
  // const location = useLocation();
  console.log(location);
  
  return(
    <div>
      <TransitionGroup className={'transition-group'}>
          <CSSTransition 
              key={location.key}
              timeout={{ enter: 20, exit: 700 }}
              classNames={'fade'}
          >
            <section className={'route-section'}>
              <Switch location={location}>
                  <Route exact path="/" component={WelcomePage} />
                  <Route path="/unit/:id" component={PointCloudPage} /> 
              </Switch>
            </section>

          </CSSTransition>
      </TransitionGroup>
    </div>

  )
}

const TransitionWithRouter = withRouter(Transition)

function App() {
  
  return (
    <Router>
      <div className="App">
        <TransitionWithRouter/>

      </div>
    </Router>
  );
}

export default App;
